import React, { Fragment } from "react";

const DiscussionOfDay = () => {
  return (
    <Fragment>
      <div className="discussion-image-description-container">
        <div className="discussion-of-day-container">
          <h1 className="large-font white">Discussion of the Day</h1>
        </div>
        <div className="flex-only">
          <div className="discussion-image-container">
            <p className="discussion-topic">Managing Frustration at Work</p>
            <img
              src={
                "https://ime.sfo3.cdn.digitaloceanspaces.com/img/frustration.jpg"
              }
              alt="picture"
              className="discussion-image"
            />
          </div>
          <div className="description-container">
            <p className="discussion-description" id="green-scroll">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas
              perspiciatis dicta blanditiis ipsum ipsa adipisci veniam in vero
              ea qui quis, modi eveniet at natus nisi.
              <br />
              <br /> Sed labore neque dolores voluptatem omnis praesentium,
              asperiores assumenda adipisci sit et accusamus perspiciatis soluta
              ipsa explicabo vitae officia minima at architecto iusto veritatis
              suscipit in. Quaerat sint deleniti, veniam corporis explicabo
              inventore quae iusto nulla cumque cupiditate quasi qui. Quae quam
              dicta quo, culpa qui assumenda a.
              <br />
              <br /> Nam labore odit obcaecati molestiae, accusantium iste,
              aperiam, laudantium dolorem reiciendis est illum voluptatem quam
              dicta! Adipisci ab quis ea cum, vitae numquam maiores perspiciatis
              veniam architecto molestias laboriosam dolore? Nisi vero hic
              placeat temporibus! Nulla, debitis impedit culpa cum non optio.
              Magnam, dolor vero. Labore quia quo, iste recusandae ipsa, velit
              quisquam, nesciunt provident autem porro consequuntur aperiam!
              Minima maiores nam, aliquam expedita labore nisi numquam similique
              veniam illum, quia iste veritatis, molestiae aperiam eligendi.
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionOfDay;
